import React from "react";
import RadioCheckButton from "common/components/RadioCheckButton/RadioCheckButton";
import SelectComponent from "features/studentFolder/components/SelectComponent/SelectComponent";

import "./StudentFolderHeader.scss";
import Input from "../../../../common/components/Input/Input";

interface Props {
  activeLesson?: number;
  onChangeLesson?: (val: number) => void;
  onSearch?: (val: string) => void;
  onCheck?: (val: string[]) => void;
  search?: string;
}

function StudentFolderHeader({ activeLesson, onChangeLesson, onSearch, onCheck, search }: Props) {
  return (
    <div className="StudentFolderHeader-main">
      <div className="heading-otr">
        <div>
          <h3 className="heading">תיק תלמיד</h3>
        </div>
        <div className="search-otr">
          <Input
            showSearchIcon
            value={search}
            placeholder="חיפוש"
            showClearButton={!!search}
            onClear={() => onSearch && onSearch("")}
            onChange={(e) => onSearch && onSearch(e.target.value)}
          />
        </div>
      </div>
      <div className="btn-check-main">
        <div className="search-select-otr">
          <div className="select-main select-main-student">
            <SelectComponent onCheck={onCheck} />
          </div>
        </div>
        <ul className="RadioCheckButton-ul-student">
          <li className="RadioCheckButton-li">
            <RadioCheckButton
              label="הכל"
              name="lessons"
              checked={activeLesson === 0}
              onClick={() => onChangeLesson && onChangeLesson(0)}
            />
          </li>
          <li className="RadioCheckButton-li">
            <RadioCheckButton
              label="פתרתי"
              name="lessons"
              checked={activeLesson === 1}
              onClick={() => onChangeLesson && onChangeLesson(1)}
            />
          </li>
          <li className="RadioCheckButton-li">
            <RadioCheckButton
              label="פתרתי מזמן"
              name="lessons"
              checked={activeLesson === 2}
              onClick={() => onChangeLesson && onChangeLesson(2)}
            />
          </li>
          <li className="RadioCheckButton-li">
            <RadioCheckButton
              label="ניסיתי"
              name="lessons"
              checked={activeLesson === 3}
              onClick={() => onChangeLesson && onChangeLesson(3)}
            />
          </li>
          <li className="RadioCheckButton-li">
            <RadioCheckButton
              label="לא התחלתי"
              name="lessons"
              checked={activeLesson === 4}
              onClick={() => onChangeLesson && onChangeLesson(4)}
            />
          </li>
        </ul>
      </div>
    </div>
  );
}

export default StudentFolderHeader;
